import { Component, forwardRef, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, ValidationErrors, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeSelectorComponent),
      multi: true
    }
  ]
})
export class DateRangeSelectorComponent implements ControlValueAccessor {
  @Input()
  label: string | null = null;
  form: FormGroup;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      start: [null],
      end: [null]
    }, { validators: [dateRangeValidator] });
    this.form.valueChanges.subscribe(v => this.onSelectChange({
      start: v?.start != null ? v.start.format('YYYY-MM-DD') : null,
      end: v?.end != null ? v.end.format('YYYY-MM-DD') : null
    }));
  }

  writeValue(value: DateRangeFormValue | null): void {
    if (value == null) {
      this.form.reset();
    } else {
      this.form.patchValue(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled)
      this.form.disable();
    else
      this.form.enable();
  }

  onSelectChange(value: DateRangeFormValue): void {
    this.onChange(value);
  }

}

export interface DateRangeFormValue {
  start: string | null;
  end: string | null;
}


const dateRangeValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const start = control.get('start')?.value;
  const end = control.get('end')?.value;

  if (!start || !end) {
    return null;
  }

  const startDate = new Date(start);
  const endDate = new Date(end);

  return startDate > endDate ? { dateRangeInvalid: true } : null;
};
